import React from 'react'
import { SearchIcon } from 'lucide-react';
import PropTypes from 'prop-types'; // Recommended for type checking in plain JavaScript/React

/**
 * @typedef {Object} SearchBoxProps
 * @property {string} searchTerm - The current value of the search input field.
 * @property {(newTerm: string) => void} setSearchTerm - The state setter function to update the search term in the parent component.
 * @property {string} [placeholder="Search..."] - The placeholder text displayed in the input field.
 */

/**
 * A reusable, controlled input component for searching.
 * It includes a search icon and styling based on CSS variables and Tailwind CSS.
 *
 * @param {SearchBoxProps} props - The component props.
 * @returns {JSX.Element} The rendered search box component.
 */
function SearchBox({ searchTerm, setSearchTerm, placeholder = "Search..." }) {
  return (
    <div className="relative w-full  mb-4">
      {/* Search Icon */}
      <span className="absolute left-3 top-2.5 text-gray-400">
        <SearchIcon size={20} /> {/* Added size prop for consistency */}
      </span>
      {/* Input Field */}
      <input
        type="text"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="w-full pl-10 pr-4 py-2 rounded-lg bg-[var(--color-surface-background)] border border-[var(--border-color)] text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 transition-all duration-200"
      />
    </div>
  )
}

export default SearchBox